import { apiSlice } from "../slices/apiSlice";

export const helpCenterApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHelpCenter: builder.query({
      query: () => ({
        url: "api/v1/help-center",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetHelpCenterQuery } = helpCenterApi;